
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell",
      function () {
        return require("private-next-pages/sell/index.tsx");
      }
    ]);
  